import { AbstractControl } from '@angular/forms';

export class EcomValidator {
    // Password validation
    static passwordValidator(control: AbstractControl): any {
        //const valPattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,20}$/;
        // const valPattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{6,20}$/;
        const valPattern = /^[a-zA-Z0-9_!@$%^&*()]{4,50}$/;
        if (control.value) {
            if (!valPattern.test(control.value)) {
                return { pattern: true };
            }
        }
        return null;
    }

    static emailValidator(control: AbstractControl): any {
        const valPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (control.value) {
            if (!valPattern.test(control.value)) {
                return { pattern: true };
            }
        }
        return null;
    }

    static wordsAndNumbersWithSpecialAndWhiteSpaces(control: AbstractControl) {
        const valPattern = /^[ A-Za-z0-9_@%*!./#&+-_\s]*$/;
        if (control.value) {
            if (!valPattern.test(control.value)) {
                return { pattern: true };
            }
        }
        return null;
    }
}